import styled, {ThemeProps} from 'styled-components';
import Image from '@stencil/image';

import {Theme} from '@stencil/build-theme/src/types';

import {Column, Row} from '../../../common/Layouts/Layouts';
import {CenteredSpaceWrap} from '../../../../CommonStyleUtils/dwebCommon.styles';

export const ContentWrapperDiv = styled.div(
  props => `
  margin: 0 auto;
  max-width: 120rem;
  padding-top: ${props.theme.spacing.large};
  background-color: ${props.theme.colors.goBrandBlue.light};
`,
);

export const OuterWrapperDiv = styled.div(
  props => `
  background-color: white;
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
`,
);

export const HeadingWrapperDiv = styled(CenteredSpaceWrap)(
  props => `
  border-bottom: 0.1rem solid ${props.theme.colors.ash.dark};
  padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.xxlarge};
  ${props.isExternal && 'justify-content: start'};
`,
);

////////////////  For external rating ////////////////////////

export const EGRHeaderDesc = styled.div(
  props => `
    color:  ${props.theme.colors.ash.base};
    font-weight: normal;
    font-size: 14px;
        margin-left: 8px;
        display: flex;
    align-items: center;
      `,
);

export const InfoIconWrapper = styled.span(
  props => `
        position: relative;
        margin-left: 4px;
        display:block;
        margin-top: 4px;
        cursor: pointer;
        &:hover > ${HiddenTooltipWrapperDiv} {
            visibility: visible;
          }
              `,
);

export const HiddenTooltipWrapperDiv = styled.div(
  props => `
    width: 34rem;
    max-width: 34rem;
    z-index: ${props.theme.misc.zIndex.base};
    visibility: hidden;
    transition: opacity 0.8s;
    padding: 12px;
    margin: ${props.theme.spacing.base} 0;
    position:absolute;
    right: -5.5rem;
    background-color: ${props.theme.colors.goWhite.base};
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    cursor: default;
  `,
);

const TipUI = styled.div(
  props => `
    position: absolute;
    margin-left: -${props.theme.spacing.base};
    width: 2.4rem;
    height: 1.2rem;
    overflow: hidden;
    &:: after {
      content: '';
      position: absolute;
      width: 1.3rem;
      height: 1.2rem;
      left: 50%;
    }
  `,
);

export const TipPositioning = styled(TipUI)(
  props => `
  right: 15%;
  top: -1.1rem;
  &::after {
    transform: translate(-50%, 50%) rotate(45deg);
    background-color: ${props.theme.colors.goWhite.base};
    box-shadow: 0 ${props.theme.spacing.xxsmall} ${props.theme.spacing.custom(4)}
      ${props.theme.colors.shadow.base};
  }
  `,
);

export const ReviewByUserWrapperDiv = styled.div(
  props => `
  display:flex;
  padding: ${props.theme.spacing.xlarge};
  border-bottom: 0.1rem solid ${props.theme.colors.ash.dark};
`,
);

export const UserReviewOuterWrapperDiv = styled(Column)(
  (props: ThemeProps<Theme>) => `
  padding: ${props.theme.spacing.xlarge};
`,
);

export const FlexContainerWrap = styled.div(
  props => `
  display:flex;
  width:50%;
  align-items: center;
`,
);
